import clsx from 'clsx'
import { Link } from './link'

export function Text({ className, ...props }) {
  return <p {...props} className={clsx('text-sm text-zinc-500', className)} />
}

export function TextLink({ className, ...props }) {
  return <Link {...props} className={clsx('font-medium text-zinc-950 underline decoration-zinc-400 underline-offset-4 hover:decoration-zinc-950', className)} />
}

export function Strong({ className, ...props }) {
  return <strong {...props} className={clsx('font-medium text-zinc-950', className)} />
}

export function Code({ className, ...props }) {
  return <code {...props} className={clsx('rounded border border-zinc-200 bg-zinc-100 px-1 py-0.5 text-xs font-medium text-zinc-950', className)} />
}
